const legendLabels: any = [
	["Not Assessed", "#045ff6", 9],
	["Compliant", "#21ba45", 9],
	["Technically Non-Compliant", "#ffff00", 9],
	["Non-Compliant", "#ff8000", 9],
	["Significantly Non-Compliant", "#ff0000", 9],
	["Remedial Works Required", "#904EE3", 9],
]
export default legendLabels
